const NATURAL_SEARCH_URL = 'v1/intent/search';

export const naturalSearch = (axiosInstance, query) => {
    return axiosInstance.post(NATURAL_SEARCH_URL, { query });
};
